import { Component, OnInit, Input } from '@angular/core';
import { MenuSearch } from './menu-search.model';

@Component({
  selector: 'menu-search',
  templateUrl: './menu-search.component.html',
  styleUrls: ['./menu-search.component.scss']
})
export class MenuSearchComponent implements OnInit {

  @Input('funcionalidades') funcionalidades: Array<MenuSearch> =[];

  constructor() { }

  filtro;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/menu-search/menu-search.component.ts